export default "__VITE_ASSET__DV7GT5LI__"